<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    amount: string;
    originalAmount?: string | null;
    hasDiscount?: boolean;
    amountClass?: string;
    wrapperClass?: string;
  }>(),
  {
    amountClass: undefined,
    hasDiscount: false,
    originalAmount: null,
    wrapperClass: undefined,
  }
);

const effectiveAmountClass = computed(
  () =>
    props.amountClass ?? (props.hasDiscount && props.originalAmount ? 'text-sm font-medium text-brand-600' : 'text-sm')
);

const effectiveWrapperClass = computed(
  () => props.wrapperClass ?? 'flex min-w-[5rem] shrink-0 flex-col items-end text-right'
);
</script>

<template>
  <div :class="effectiveWrapperClass">
    <template v-if="hasDiscount && originalAmount">
      <span class="text-xs text-gray-400 line-through">{{ originalAmount }}</span>

      <span :class="effectiveAmountClass">{{ amount }}</span>
    </template>

    <span
      v-else
      :class="effectiveAmountClass"
    >
      {{ amount }}
    </span>
  </div>
</template>
